import React from 'react';
import { Avatar, Box, Typography, IconButton, Grid, Divider, Tooltip } from '@mui/material';
import { PersonAdd, CheckCircle } from '@mui/icons-material';
import { useTranslation } from 'react-i18next';

const TeamDetails = ({ teamData, handleToConnect ,isConnected}) => {
    const {t}=useTranslation();
    return (
         <Grid container spacing={2}>
            <Grid item xs={12}>
            
            <Typography variant="h5" sx={{ my: 4 }}>{t("TeamMembers")}</Typography>
            <Grid container spacing={2}>
            {teamData?.map(member => (
                <Grid container alignItems="center" spacing={2} key={member.id} sx={{ margin: 2, padding: 2, border: '1px solid #e0e0e0', borderRadius: 2 , maxWidth: 345 }}>
                    <Grid item>
                        <Avatar src={member.profile_pic} alt={`${member.name}'s profile`} sx={{ width: 60, height: 60 }} />
                    </Grid>
                    <Grid item xs>
                        <Typography variant="h6">{member.name}</Typography>
                        <Typography variant="body2" color="textSecondary">{member.designation}</Typography>
                    </Grid>
                    <Grid item>
                        <Tooltip title={isConnected ? t("removeFromMyConnection"):t("AddToMyConnection")}>
                            <IconButton onClick={() => handleToConnect(member.id)}>
                                {isConnected ? <CheckCircle color="success" /> : <PersonAdd />}
                            </IconButton>
                        </Tooltip>
                    </Grid>
                </Grid>
            ))}
            </Grid>
            </Grid>
        </Grid>
    );
};

export default TeamDetails;